import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const Services = () => {
  return (
    <>
      <Helmet>
        <title>Our Services - Ursus Victor LLC | Loan Application Support</title>
        <meta name="description" content="Professional loan application support services including document preparation, application assistance, and submission guidance." />
      </Helmet>

      {/* Hero Section */}
      <section style={{
        background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
        color: 'white',
        padding: '5rem 2rem',
        textAlign: 'center'
      }}>
        <div style={{maxWidth: '900px', margin: '0 auto'}}>
          <h1 style={{fontSize: '3.5rem', fontWeight: '900', marginBottom: '1.5rem'}}>
            Our Services
          </h1>
          <p style={{fontSize: '1.4rem', opacity: 0.95, lineHeight: '1.7'}}>
            Comprehensive loan application support from start to finish
          </p>
        </div>
      </section>

      {/* Main Services */}
      <section style={{padding: '5rem 2rem', background: 'white'}}>
        <div style={{maxWidth: '1100px', margin: '0 auto'}}>
          <div style={{display: 'grid', gap: '3rem'}}>
            {/* Service 1 */}
            <div style={{
              background: '#f8fafc',
              padding: '3rem',
              borderRadius: '20px',
              border: '3px solid #e2e8f0',
              display: 'grid',
              gridTemplateColumns: '1fr 2fr',
              gap: '3rem',
              alignItems: 'center'
            }}>
              <div style={{textAlign: 'center'}}>
                <div style={{fontSize: '6rem', marginBottom: '1rem'}}>📝</div>
                <h3 style={{fontSize: '2rem', fontWeight: '900', color: '#1e40af'}}>
                  Application Assistance
                </h3>
              </div>
              <div>
                <p style={{fontSize: '1.15rem', color: '#475569', lineHeight: '1.9', marginBottom: '1.5rem'}}>
                  Expert guidance through the entire loan application process. We help you understand requirements, 
                  complete forms accurately, and avoid common mistakes that can delay approval.
                </p>
                <ul style={{fontSize: '1.05rem', color: '#64748b', lineHeight: '2', marginLeft: '1.5rem'}}>
                  <li>Form completion assistance</li>
                  <li>Requirement clarification</li>
                  <li>Application review and verification</li>
                  <li>Error checking and correction</li>
                  <li>Submission preparation</li>
                </ul>
                <Link to="/services/application-support" style={{
                  display: 'inline-block',
                  marginTop: '1.5rem',
                  background: '#3b82f6',
                  color: 'white',
                  padding: '0.875rem 2rem',
                  borderRadius: '10px',
                  fontWeight: '700'
                }}>
                  Learn More →
                </Link>
              </div>
            </div>

            {/* Service 2 */}
            <div style={{
              background: '#f8fafc',
              padding: '3rem',
              borderRadius: '20px',
              border: '3px solid #e2e8f0',
              display: 'grid',
              gridTemplateColumns: '2fr 1fr',
              gap: '3rem',
              alignItems: 'center'
            }}>
              <div>
                <p style={{fontSize: '1.15rem', color: '#475569', lineHeight: '1.9', marginBottom: '1.5rem'}}>
                  Professional support organizing and preparing all required documentation for your loan application. 
                  We ensure your documents are complete, properly formatted, and ready for submission.
                </p>
                <ul style={{fontSize: '1.05rem', color: '#64748b', lineHeight: '2', marginLeft: '1.5rem'}}>
                  <li>Document checklist creation</li>
                  <li>Financial statement organization</li>
                  <li>Tax return compilation</li>
                  <li>Bank statement preparation</li>
                  <li>Supporting document assembly</li>
                </ul>
                <Link to="/services/document-preparation" style={{
                  display: 'inline-block',
                  marginTop: '1.5rem',
                  background: '#3b82f6',
                  color: 'white',
                  padding: '0.875rem 2rem',
                  borderRadius: '10px',
                  fontWeight: '700'
                }}>
                  Learn More →
                </Link>
              </div>
              <div style={{textAlign: 'center'}}>
                <div style={{fontSize: '6rem', marginBottom: '1rem'}}>📄</div>
                <h3 style={{fontSize: '2rem', fontWeight: '900', color: '#1e40af'}}>
                  Document Preparation
                </h3>
              </div>
            </div>

            {/* Service 3 */}
            <div style={{
              background: '#f8fafc',
              padding: '3rem',
              borderRadius: '20px',
              border: '3px solid #e2e8f0',
              display: 'grid',
              gridTemplateColumns: '1fr 2fr',
              gap: '3rem',
              alignItems: 'center'
            }}>
              <div style={{textAlign: 'center'}}>
                <div style={{fontSize: '6rem', marginBottom: '1rem'}}>✅</div>
                <h3 style={{fontSize: '2rem', fontWeight: '900', color: '#1e40af'}}>
                  Application Review
                </h3>
              </div>
              <div>
                <p style={{fontSize: '1.15rem', color: '#475569', lineHeight: '1.9', marginBottom: '1.5rem'}}>
                  Comprehensive review of your complete application package before submission. We check for accuracy, 
                  completeness, and compliance with lender requirements.
                </p>
                <ul style={{fontSize: '1.05rem', color: '#64748b', lineHeight: '2', marginLeft: '1.5rem'}}>
                  <li>Accuracy verification</li>
                  <li>Completeness check</li>
                  <li>Requirement compliance review</li>
                  <li>Error identification and correction</li>
                  <li>Final quality assurance</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Additional Services */}
      <section style={{padding: '5rem 2rem', background: '#f8fafc'}}>
        <div style={{maxWidth: '1100px', margin: '0 auto'}}>
          <div style={{textAlign: 'center', marginBottom: '4rem'}}>
            <h2 style={{fontSize: '2.8rem', fontWeight: '900', color: '#1e3a8a', marginBottom: '1rem'}}>
              Additional Support Services
            </h2>
            <p style={{fontSize: '1.2rem', color: '#64748b'}}>
              Comprehensive assistance for every aspect of your loan application
            </p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '2rem'
          }}>
            {[
              {
                icon: '💼',
                title: 'Business Plan Support',
                desc: 'Guidance on preparing business plans and financial projections for business loan applications'
              },
              {
                icon: '📊',
                title: 'Financial Statement Prep',
                desc: 'Help organizing profit & loss statements, balance sheets, and cash flow statements'
              },
              {
                icon: '🏦',
                title: 'Bank Statement Organization',
                desc: 'Proper formatting and presentation of personal and business banking records'
              },
              {
                icon: '📑',
                title: 'Tax Return Compilation',
                desc: 'Gathering and organizing personal and business tax returns for submission'
              },
              {
                icon: '🔍',
                title: 'Credit Report Review',
                desc: 'Help understanding credit reports and identifying areas that may need explanation'
              },
              {
                icon: '📧',
                title: 'Lender Communication',
                desc: 'Guidance on responding to lender questions and additional document requests'
              },
              {
                icon: '📝',
                title: 'Letter of Explanation',
                desc: 'Assistance drafting letters to explain credit issues or unusual circumstances'
              },
              {
                icon: '🎯',
                title: 'Requirement Checklist',
                desc: 'Custom checklists ensuring you have everything needed for your specific loan type'
              },
              {
                icon: '⚡',
                title: 'Rush Service Available',
                desc: 'Expedited support for time-sensitive applications with tight deadlines'
              }
            ].map((service, index) => (
              <div key={index} style={{
                background: 'white',
                padding: '2.5rem',
                borderRadius: '16px',
                border: '2px solid #e2e8f0',
                transition: 'transform 0.3s'
              }}>
                <div style={{fontSize: '3.5rem', marginBottom: '1.5rem'}}>{service.icon}</div>
                <h3 style={{fontSize: '1.5rem', fontWeight: '800', color: '#1e40af', marginBottom: '1rem'}}>
                  {service.title}
                </h3>
                <p style={{color: '#64748b', lineHeight: '1.8'}}>
                  {service.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Loan Types */}
      <section style={{padding: '5rem 2rem', background: 'white'}}>
        <div style={{maxWidth: '1100px', margin: '0 auto'}}>
          <div style={{textAlign: 'center', marginBottom: '4rem'}}>
            <h2 style={{fontSize: '2.8rem', fontWeight: '900', color: '#1e3a8a', marginBottom: '1rem'}}>
              Loan Types We Support
            </h2>
            <p style={{fontSize: '1.2rem', color: '#64748b'}}>
              Application support for all major loan categories
            </p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '1.5rem'
          }}>
            {[
              'Personal Loans',
              'Business Loans',
              'Mortgage Loans',
              'Auto Loans',
              'Student Loans',
              'Home Equity Loans',
              'SBA Loans',
              'Commercial Real Estate',
              'Equipment Financing',
              'Lines of Credit',
              'Construction Loans',
              'Refinancing'
            ].map((type, index) => (
              <div key={index} style={{
                background: '#f8fafc',
                padding: '1.5rem',
                borderRadius: '12px',
                border: '2px solid #e2e8f0',
                textAlign: 'center',
                fontWeight: '700',
                color: '#1e40af',
                fontSize: '1.1rem'
              }}>
                ✓ {type}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process */}
      <section style={{padding: '5rem 2rem', background: '#f8fafc'}}>
        <div style={{maxWidth: '1000px', margin: '0 auto'}}>
          <div style={{textAlign: 'center', marginBottom: '4rem'}}>
            <h2 style={{fontSize: '2.8rem', fontWeight: '900', color: '#1e3a8a', marginBottom: '1rem'}}>
              How Our Service Works
            </h2>
          </div>

          <div style={{display: 'grid', gap: '2rem'}}>
            {[
              { step: '1', title: 'Contact Us', desc: 'Reach out via our contact form or email to discuss your needs' },
              { step: '2', title: 'Consultation', desc: 'We review your situation and explain how we can help' },
              { step: '3', title: 'Document Gathering', desc: 'We provide a checklist and help you collect required documents' },
              { step: '4', title: 'Application Prep', desc: 'We assist with completing forms and organizing materials' },
              { step: '5', title: 'Review & Verify', desc: 'We thoroughly review everything for accuracy and completeness' },
              { step: '6', title: 'Submission Guidance', desc: 'We provide instructions for submitting to your lender' }
            ].map((item, index) => (
              <div key={index} style={{
                display: 'flex',
                gap: '2rem',
                alignItems: 'center',
                padding: '2rem',
                background: 'white',
                borderRadius: '16px',
                border: '2px solid #e2e8f0'
              }}>
                <div style={{
                  background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
                  color: 'white',
                  width: '70px',
                  height: '70px',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '2rem',
                  fontWeight: '900',
                  flexShrink: 0
                }}>
                  {item.step}
                </div>
                <div>
                  <h3 style={{fontSize: '1.6rem', fontWeight: '800', color: '#1e40af', marginBottom: '0.5rem'}}>
                    {item.title}
                  </h3>
                  <p style={{color: '#64748b', lineHeight: '1.7', fontSize: '1.05rem'}}>
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{
        background: 'linear-gradient(135deg, #1e3a8a 0%, #1e40af 50%, #3b82f6 100%)',
        color: 'white',
        padding: '5rem 2rem',
        textAlign: 'center'
      }}>
        <div style={{maxWidth: '800px', margin: '0 auto'}}>
          <h2 style={{fontSize: '2.8rem', fontWeight: '900', marginBottom: '1.5rem'}}>
            Need Application Support?
          </h2>
          <p style={{fontSize: '1.3rem', marginBottom: '2.5rem', opacity: 0.95, lineHeight: '1.6'}}>
            Let us help you prepare a complete, professional loan application
          </p>
          <Link to="/contact" style={{
            background: 'white',
            color: '#1e40af',
            padding: '1.5rem 3.5rem',
            borderRadius: '12px',
            fontWeight: '900',
            fontSize: '1.3rem',
            display: 'inline-block',
            boxShadow: '0 12px 40px rgba(0,0,0,0.3)'
          }}>
            Get Started Today
          </Link>
        </div>
      </section>

      {/* Disclaimer */}
      <section style={{
        background: '#fef3c7',
        padding: '2.5rem 2rem',
        borderTop: '3px solid #f59e0b'
      }}>
        <div style={{maxWidth: '1000px', margin: '0 auto', textAlign: 'center'}}>
          <p style={{fontSize: '1rem', color: '#92400e', lineHeight: '1.8', fontWeight: '600'}}>
            <strong>IMPORTANT DISCLOSURE:</strong> Ursus Victor LLC provides loan application support services only. 
            We are NOT a lender, do NOT make loans, and do NOT make lending decisions. We do NOT guarantee loan approval. 
            All lending decisions are made solely by financial institutions.
          </p>
        </div>
      </section>
    </>
  );
};

export default Services;
